<template>
  <div class="headerbar headerbar-page">
    <div class="headerbar-header">
      <div class="headerbar-color headerbar-color-1" @click="navigationFunction">
        <img :src="getImage('arrowLeft.svg')" class="back-arrow" alt="Zurück">
      </div>
      <div class="headerbar-color headerbar-color-2">
        <div class="headerbar-field"><span>Medau</span>physio</div>
      </div>
      <div class="headerbar-color headerbar-color-3">
        <div class="headerbar-field"><span>Medau</span>logo</div>
      </div>
      <div class="headerbar-color headerbar-color-4">
        <div class="headerbar-field"><span>Medau</span>ergo</div>
      </div>
      <div class="headerbar-color headerbar-color-5">
        <div class="headerbar-field"><span>Medau</span>fit</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "career",
  ],
  methods: {
    navigationFunction() {
      if(this.career === true) {
        this.$router.go(-1);
      } else {
        this.$router.push('/');
      }
    }
  }
}
</script>